export enum Title {
    MALE = 'herr',
    FEMALE = 'frau',
}

export enum LeadManagementAction {
    SUBMIT = 'IP/LEAD_MANAGEMENT/SUBMIT',
    SET_RESULT = 'IP/LEAD_MANAGEMENT/SET_RESULT',
    SET_FORM = 'IP/LEAD_MANAGEMENT/SET_FORM',
    SET_ERROR = 'IP/LEAD_MANAGEMENT/SET_ERROR',
};

export enum LeadManagementId {
    TITLE_INPUT = 'fixnet-lead-management-title-input',
    FIRSTNAME_INPUT = 'fixnet-lead-management-firstname-input',
    LASTNAME_INPUT = 'fixnet-lead-management-lastname-input',
    EMAIL_INPUT = 'fixnet-lead-management-email-input',
    SUBMIT = 'fixnet-lead-management-submit',
    RESULT_NOTIFICATION = 'fixnet-lead-management-result-notification',
    ERROR_NOTIFICATION = 'fixnet-lead-management-error-notification',
    FORM = 'fixnet-lead-management-form',
}
